/**
 * 文档管理模块路由配置
 */
import type { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'
import {
  DocumentUpload,
  DocumentTranslation,
  DocumentResults
} from '@/modules/document/views'

const documentRoutes: RouteRecordRaw[] = [
  // 文档翻译模块（document 命名空间）
  {
    // 与 Nginx 根路径 /document/ 文件直链区分：文件走 /document/YYYY/...，SPA 走 /doc-workflow/*
    path: 'doc-workflow',
    name: 'Document',
    meta: {
      titleKey: 'menu.documentTranslation',
      title: '文档翻译',
      requiresAuth: true,
      permissions: [
        Permission.DOCUMENT_UPLOAD,
        Permission.DOCUMENT_TRANSLATE,
        Permission.DOCUMENT_EDIT
      ],
      icon: 'FileTextOutlined'
    },
    children: [
      {
        path: 'upload',
        name: 'DocumentUpload',
        component: DocumentUpload,
        meta: {
          titleKey: 'menu.documentUpload',
          title: '上传文档',
          requiresAuth: true,
          permissions: [Permission.DOCUMENT_UPLOAD],
          breadcrumb: true
        }
      },
      {
        path: 'translation/:id',
        name: 'DocumentTranslation',
        component: DocumentTranslation,
        meta: {
          title: '文档翻译',
          requiresAuth: true,
          permissions: [Permission.DOCUMENT_TRANSLATE, Permission.TASK_EDIT],
          breadcrumb: true,
          hidden: true
        }
      },
      {
        path: 'results/:id',
        name: 'DocumentResults',
        component: DocumentResults,
        meta: {
          title: '文档翻译结果',
          requiresAuth: true,
          permissions: [Permission.DOCUMENT_TRANSLATE],
          breadcrumb: true,
          hidden: true
        }
      }
    ]
  }
]

export default documentRoutes


